/**
 * 拼图卡片组件
 * 统一管理全站拼图卡片的显示样式
 */
import { I18nManager } from '../core/I18nManager';

export interface PuzzleData {
    puzzle_id: string;
    puzzle_name: string;
    image_url: string;
    uploader_name: string;
    uploader_avatar: string;
    play_count: number;
    access_level?: string;
    slug?: string;
}

export class PuzzleCard {
    /**
     * 渲染卡片 HTML
     * @param pic 拼图数据
     * @param options 配置项
     */
    static render(pic: PuzzleData, options: { showPrivateBadge?: boolean } = {}): string {
        const lang = I18nManager.getInstance().getCurrentLanguage();
        const langPrefix = lang === 'en' ? '' : `/${lang.toLowerCase()}`;
        const href = pic.slug ? `${langPrefix}/puzzle/${pic.slug}` : `javascript:void(0)`;
        return `
            <a href="${href}" class="puzzle-card group relative aspect-square rounded-xl overflow-hidden cursor-pointer bg-stone-100 shadow-sm hover:shadow-md transition-all block" data-id="${pic.puzzle_id}">
                <img src="${pic.image_url}"
                     class="puzzle-img w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                     alt="${pic.puzzle_name}"
                     loading="lazy"
                     onerror="this.src='assets/picture/10001.jpg'">

                <!-- 悬停播放图标 -->
                <div class="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-[1px]">
                    <div class="w-12 h-12 bg-white text-stone-900 rounded-full flex items-center justify-center shadow-xl transform translate-y-4 group-hover:translate-y-0 transition-all duration-300">
                        <iconify-icon icon="solar:play-bold" width="20"></iconify-icon>
                    </div>
                </div>

                <!-- 作者与热度 (始终显示) -->
                <div class="absolute bottom-3 left-3 right-3 flex items-end justify-between pointer-events-none z-10">
                    <div class="flex items-center gap-2 bg-black/50 backdrop-blur-md px-3 py-1.5 rounded-full border border-white/10 shadow-sm">
                        <img src="${pic.uploader_avatar || ''}" class="w-7 h-7 rounded-full border border-white/20" onerror="this.style.display='none'">
                        <span class="text-[18px] text-white font-bold tracking-tight">${pic.uploader_name || '匿名'}</span>
                    </div>
                    <div class="bg-black/50 backdrop-blur-md px-3 py-1.5 rounded-full border border-white/10 text-[12px] text-white/90 flex items-center gap-1 shadow-sm mb-1">
                        <iconify-icon icon="solar:fire-bold" width="11" class="text-orange-400"></iconify-icon>
                        ${pic.play_count || 0}
                    </div>
                </div>

                <!-- 权限角标 (可选显示) -->
                ${options.showPrivateBadge && pic.access_level === 'private' ? `
                    <div class="absolute top-3 right-3 bg-stone-900/80 backdrop-blur px-2 py-1 rounded-lg text-[10px] text-white flex items-center gap-1 z-10">
                        <iconify-icon icon="solar:lock-bold" width="10"></iconify-icon>
                        仅自己可见
                    </div>
                ` : ''}
            </a>
        `;
    }
}
